export class TokenEvents {
    public static ITEM_PURCHASE = 'ITEM_PURCHASE';
    public static ADJUSTMENT = 'ADJUSTMENT';
}
